class OpenTableLocationPicker extends HTMLElement {
  constructor() {
    super();
    this.locationTiles = [];
    this.calendarContainers = [];
    this.currentLocationId = null;
    this.locationNameMap = {}; // Map slugs to location IDs
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.locationTiles = Array.from(this.querySelectorAll('.location-tile'));
    this.calendarContainers = Array.from(this.querySelectorAll('.opentable-location-section'));

    if (this.locationTiles.length === 0) {
      console.error('OpenTable Location Picker: No location tiles found');
      return;
    }

    if (this.calendarContainers.length === 0) {
      console.error('OpenTable Location Picker: No location sections found');
      return;
    }

    // Build a map of location name slugs to IDs
    this.locationTiles.forEach((tile) => {
      const locationName = tile.getAttribute('data-location-name');
      const locationId = tile.getAttribute('data-location-id');
      if (locationName && locationId) {
        const slug = this.slugify(locationName);
        this.locationNameMap[slug] = locationId;
      }
    });

    // Handle location tile selection
    this.locationTiles.forEach((tile) => {
      tile.addEventListener('click', (e) => this.handleTileClick(e));
    });

    // Check for location in URL fragment on page load
    this.checkAndLoadFragmentLocation();

    // Listen for hash changes (browser back/forward)
    window.addEventListener('hashchange', () => this.checkAndLoadFragmentLocation());
  }

  slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // Remove special characters
      .replace(/[\s_]+/g, '-') // Replace spaces and underscores with hyphens
      .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
  }

  checkAndLoadFragmentLocation() {
    const hash = window.location.hash.slice(1); // Remove the # character

    if (hash) {
      // Check if hash matches a location slug
      const locationId = this.locationNameMap[hash];

      if (locationId) {
        this.showCalendarForLocation(locationId);
      }
    }
  }

  handleTileClick(event) {
    const selectedLocationId = event.currentTarget.getAttribute('data-location-id');

    if (!selectedLocationId) {
      this.hideAllCalendars();
      return;
    }

    this.showCalendarForLocation(selectedLocationId);
  }

  showCalendarForLocation(locationId) {
    // Update tile active states
    this.locationTiles.forEach((tile) => {
      if (tile.getAttribute('data-location-id') === locationId) {
        tile.classList.add('location-tile--active');
      } else {
        tile.classList.remove('location-tile--active');
      }
    });

    // Hide all calendars first
    this.calendarContainers.forEach((container) => {
      container.style.display = 'none';
    });

    // Show the selected calendar - use specific selector to avoid matching tiles
    const selectedContainer = this.querySelector(`.opentable-location-section[data-location-id="${locationId}"]`);
    if (selectedContainer) {
      selectedContainer.style.display = 'block';
      this.currentLocationId = locationId;

      // Get the location name from the tile and create a slug for the URL
      const locationTile = this.querySelector(`.location-tile[data-location-id="${locationId}"]`);
      if (locationTile) {
        const locationName = locationTile.getAttribute('data-location-name');
        const slug = this.slugify(locationName);
        // Update URL fragment without triggering hashchange event
        window.history.replaceState(null, null, `#${slug}`);
      }
    }
  }

  hideAllCalendars() {
    // Remove active state from all tiles
    this.locationTiles.forEach((tile) => {
      tile.classList.remove('location-tile--active');
    });

    // Hide all calendars
    this.calendarContainers.forEach((container) => {
      container.style.display = 'none';
    });
    this.currentLocationId = null;
  }
}

// Register the custom element
if (!customElements.get('opentable-location-picker')) {
  customElements.define('opentable-location-picker', OpenTableLocationPicker);
}
